import {
  DollarOutlined,
  FileTextOutlined,
  UserOutlined,
} from '@ant-design/icons';

export const searchInputInitialValues = {
  search: { filter: 'order_number' },
};

export const searchFilters = [
  { value: 'order_number', label: 'Venta' },
  { value: 'seller.name', label: 'Vendedor' },
  { value: 'customer.name', label: 'Cliente' },
  { value: 'payReference', label: 'Referencia' },
];

export const posSearchFilters = [
  { value: 'order_number', label: 'Venta' },
  { value: 'customer.name', label: 'Cliente' },
];

export const saleTypeConst = Object.freeze({
  POS: 'POS',
  APP: 'App',
  ONLINE: 'online',
});

export const filters = {
  search: true,
  date: true,
  branches: true,
  dates: true,
  paymentMethod: true,
  paymentStatus: true,
  treatmentStatus: true,
  redemptionBranch: true,
};

export { paymentProcessType as paymentGatewayOptions } from './Setting.const';

export const treatmentStatusOptions = [
  { value: 'pending', label: 'Sin iniciar' },
  { value: 'onProcess', label: 'En proceso' },
  { value: 'finished', label: 'Finalizado' },
  { value: 'refunded', label: 'Cancelado' },
  { value: 'expired', label: 'Caducado' },
  { value: 'mixed', label: 'Estado mixto' },
];

export const treatmentStatusDictionary = treatmentStatusOptions.reduce(
  (dictionary, status) => ({
    ...dictionary,
    [status.value]: status.label,
  }),
  {}
);

export const salesConst = {
  DETAIL: 'Detalle',
  REFUND: 'Devolución',
  PAYMENT_TYPE: 'Tipo de pago',
};

export const onlineSaleDetailConst = {
  EMPTY_VALUE: '—',
  ACQUISITION_DATE: 'Fecha de adquisición',
  INITIAL_REDEMPTION_BRANCH: 'Sucursal de canje inicial',
  RESPONSIBLE_REDEMPTION_BRANCH: 'Sucursal responsable de canje',
  TREATMENTS_TITLE: 'Tratamientos contenidos en la orden',
  SESSIONS_TITLE: 'Sesiones registradas de la orden',
  TRANSFERS_TITLE: 'Bitácora de traslados de la orden',
  COLUMNS: {
    TREATMENT: 'Tratamiento',
    STATUS: 'Estado',
    PURCHASED: 'Adquiridas',
    USED: 'Utilizadas',
    AVAILABLE: 'Disponibles',
    INITIAL_REDEMPTION_BRANCH: 'Sucursal de canje inicial',
    RESPONSIBLE_REDEMPTION_BRANCH: 'Sucursal responsable de canje',
    EXPIRATION_DATE: 'Fecha de caducidad',
    DATE_TIME: 'Fecha y hora',
    BRANCH: 'Sucursal',
    ATTENDED_BY: 'Médico o cosmetóloga que atendió',
    REGISTERED_BY: 'Usuario responsable del registro',
    ORIGIN_BRANCH: 'Sucursal de origen',
    DESTINATION_BRANCH: 'Sucursal de destino',
    REASON: 'Motivo',
    EXECUTED_BY: 'Usuario que ejecutó',
  },
  EMPTY_STATES: {
    TREATMENTS: 'No hay tratamientos vinculados a esta orden',
    SESSIONS: 'No hay sesiones registradas para esta orden',
    TRANSFERS: 'Sin cambios de sucursal registrados',
  },
};

export const paymentMethod = [
  { value: 'GETNET', label: 'GETNET' },
  { value: 'Efectivo', label: 'Efectivo' },
  { value: 'Puntos', label: 'Puntos' },
  { value: 'Tarjeta de crédito/débito', label: 'Tarjeta de crédito/débito' },
];

export const refundMethod = [
  { value: 'Efectivo', label: 'Efectivo' },
  { value: 'Tarjeta de crédito', label: 'Tarjeta de crédito' },
  { value: 'Tarjeta de débito', label: 'Tarjeta de débito' },
];

export const paymentStatusDictionary = {
  paid: 'Pagado',
  error: 'Error',
  pending_payment: 'Pago pendiente',
  pending_confirmation: 'Por confirmar',
};

export const paymentStatusOptions = Object.entries(paymentStatusDictionary).map(
  ([value, label]) => ({ value, label })
);

export const originSaleDictionary = {
  app: 'APP',
  pos: 'SUCURSAL',
  online: 'LINEA',
};

export const salesTableMenuOpt = [
  {
    label: 'Ver cliente',
    key: 'customer',
    icon: <UserOutlined />,
    privilege: 'view',
  },
  {
    label: 'Recibo',
    key: 'invoice',
    icon: <FileTextOutlined />,
    privilege: 'view',
  },
  {
    label: 'Devolución',
    key: 'refund',
    icon: <DollarOutlined />,
    privilege: 'refund',
  },
];

export const paymentProcessTypesConst = {
  santander: 'Santander',
};

export const cashPaymentMethodOptions = [
  { value: 'Efectivo', label: 'Efectivo' },
  { value: 'GETNET', label: 'GETNET' },
];
